/**
 * Minimal toast bus. A dependency-free publisher the shell subscribes to, so any module can
 * report an outcome without threading a callback through every screen.
 */
export type ToastTone = 'success' | 'error' | 'info';
export interface ToastMessage { id: number; tone: ToastTone; text: string; title?: string; items?: string[] }

type Listener = (message: ToastMessage) => void;

const listeners = new Set<Listener>();
let nextId = 1;

function publish(tone: ToastTone, text: string, extra?: { title?: string; items?: string[] }) {
  const message: ToastMessage = { id: nextId++, tone, text, ...extra };
  listeners.forEach((listener) => listener(message));
}

export const toast = {
  success: (text: string) => publish('success', text),
  /** Errors open a dialog that stays until dismissed (owner, 2026-09-21), not a passing toast. */
  error: (text: string) => publish('error', text),
  /** Several problems at once - a form that will not save - as a numbered list in one dialog. */
  errors: (title: string, items: string[]) => publish('error', items.join(' '), { title, items }),
  info: (text: string) => publish('info', text),
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
